import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { DireccionesComponent } from 'src/app/direcciones/direcciones.component';
import { AceptaSolicitudComponent } from 'src/app/modales/acepta-solicitud/acepta-solicitud.component';
import { CodeudoresExternosComponent } from 'src/app/modales/codeudores-externos/codeudores-externos.component';
import { PagarePrincipalComponent } from 'src/app/modales/pagare-principal/pagare-principal.component';
import { RecogeCreditosComponent } from 'src/app/modales/recoge-creditos/recoge-creditos.component';
import { ViewTrackingComponent } from 'src/app/modales/view-tracking/view-tracking.component';
import { solicitud } from 'src/app/models/solicitud';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { ciudades } from 'src/app/models/ciudades';

export interface DialogData {
  monto: string
}

@Component({
  selector: 'app-solicitudes-new',
  templateUrl: './solicitudes-new.component.html',
  styleUrls: ['./solicitudes-new.component.css']
})
export class SolicitudesNewComponent implements OnInit {
  public identity
  public config
  public solicitudes
  public solicitudes_codeudor: any;
  public creaSolicitud = false;
  public mobile: boolean;
  public width: any;
  public grupos = new Array();
  public solicitud
  public select = new Array();
  public check = new Array();
  private montoMax: number
  private montoMin: number

  public autorizaciones = []
  private docs = []

  CiudadNombreFiltrada: any;
  grupoLaboral: any;
  grupoSolicitud: any;
  lineasCredito: any;
  condicionesLineaCredito: any;
  plazos: any[];
  Frecuencia: any;
  carteraRecoge: any;
  closeResult: string;
  grupoRefFam1: any;
  grupoRefFam2: any;
  grupoRefPer2: any;
  grupoRefPer1: any;
  grupoCodeudor: any;
  codeudor = new Array();
  grupoDocumetos: any;
  documentos = new Array();
  datosGenerales: any;

  private formularioSolicitud: any;
  private grupoAsociados: any;
  private basicos = new Array();
  private solic = new Array();
  private grupoFinanciera: any;
  private camposSeparadosS: any;
  private camposSeparadosN: any;
  private ciudadFiltrada: any;
  private ciudadesFiltrada: any;
  private jsonSend: any;
  public campoFiltrada: any;

  public lineal = environment.production
  public entidadActual = environment.actual;
  public aplicaActualizaDatos = environment.entidad[this.entidadActual].activaActualizacionDatos;
  public entidadNombreCompleto = environment.entidad[this.entidadActual].nombreFondoCompleto;
  public entidadNombre = environment.entidad[this.entidadActual].entidadNombre;
  public nombreCompletoEntidad = environment.entidad[this.entidadActual].nombreFondoCompleto;
  private url = environment.entidad[this.entidadActual].urlEndPoint;
  private color = environment.entidad[this.entidadActual].colorMenu
  private pdfDeceval = environment.entidad[this.entidadActual].pdfDeceval

  public urlImg = this.url + 'docSolicitud'
  destinos: any;


  constructor(
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public dialog: MatDialog,
    private router: Router,
    private messageService: MessageService) {
    this.config = JSON.parse(this._userService.GetsessionStorage('config'));
    this.campoFiltrada = new ciudades();
  }

  async ngOnInit() {
    this.identity = await JSON.parse(this._userService.GetsessionStorage('identity'));

    this.solicitud = new solicitud()
    this.getSolicitudes()
    this.getSolicitudesCodeudor()
    if (window.screen.width > 768) {
      this.mobile = true;
      this.width = '3';
    } else {
      console.log(window.screen.width)
      this.mobile = false;
      this.width = '12'
    }
  }

  getSolicitudes() {
    this.spinner.show();
    this._userService.httpGet('listarSolicitudes/' + this.identity.CODUNICO).subscribe(response => {
      this.spinner.hide();
      if (response.status == 'error') {
        alert(response.message);
      } else {
        console.log(response.details);
        this.solicitudes = response.details;
      }
    },
      error => {
        this.spinner.hide();
        console.log(error as any);
      }
    );
  }

  getSolicitudesCodeudor() {
    this.spinner.show();
    this._userService.httpGet('listarSolicitudesCodeudor/' + this.identity.CODUNICO).subscribe(response => {
      this.spinner.hide();
      if (response.status == 'error') {
        alert(response.message);
      } else {
        this.solicitudes_codeudor = response.details;
      }
    },
      error => {
        this.spinner.hide();
        console.log(error as any);
      }
    );
  }

  crearSolicitud() {
    this.spinner.show();
    this._userService.httpGet('validarActualizacion/' + this.identity.CODASOCIADO).subscribe(resp => {
      if ((resp.ACTUALIZA === 1 || resp.ACTUALIZA === '1') && this.aplicaActualizaDatos) {
        this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Para radicar una nueva solicitud es necesario actualizar tus datos' });
        //alert('');
        setTimeout(() => {
          this.router.navigateByUrl('actualizacion');
        }, 5000);
      } else {
        this.getForm()
      }
    }, error => {
      this.spinner.hide();
      //alert('error: '+ error)
      console.log(error);
    });
  }

  getForm() {
    this.spinner.show()
    this.creaSolicitud = true
    this.getLineasCredito();
    this.getFrecuencia()
    this.getDestinoCredito()
    this.CargarAutorizacion()
    this._userService.httpGet('getParamsSolicitud').subscribe(
      (response: any) => {

        if (response.status == 'success') {
          this.formularioSolicitud = response.details;
          this.grupoAsociados = this.formularioSolicitud.filter(item => item.SUBGRUPO == 'DATOS ASOCIADO');
          this.grupoFinanciera = this.formularioSolicitud.filter(item => item.SUBGRUPO == 'INFORMACION FINANCIERA');
          this.grupoLaboral = this.formularioSolicitud.filter(item => item.SUBGRUPO == 'INFORMACION LABORAL');
          this.grupoSolicitud = this.formularioSolicitud.filter(item => item.SUBGRUPO == 'DATOS SOLICITUD');
          this.grupoRefFam1 = this.formularioSolicitud.filter(item => item.SUBGRUPO == 'REFERENCIA FAMILIAR 1');
          this.grupoRefFam2 = this.formularioSolicitud.filter(item => item.SUBGRUPO == 'REFERENCIA FAMILIAR 2');
          this.grupoRefPer1 = this.formularioSolicitud.filter(item => item.SUBGRUPO == 'REFERENCIA PERSONAL 1');
          this.grupoRefPer2 = this.formularioSolicitud.filter(item => item.SUBGRUPO == 'REFERENCIA PERSONAL 2');
          this.grupoCodeudor = this.formularioSolicitud.filter(item => item.SUBGRUPO == 'CODEUDORES');
          this.grupoDocumetos = this.formularioSolicitud.filter(item => item.SUBGRUPO == 'DOCUMENTOS');



          if ((typeof this.grupoAsociados !== 'undefined' && this.grupoAsociados.length > 0) ||
            (typeof this.grupoFinanciera !== 'undefined' && this.grupoFinanciera.length > 0) ||
            (typeof this.grupoLaboral !== 'undefined' && this.grupoLaboral.length > 0)) {
            this.basicos.push('DATOS PERSONALES')
            this.basicos.push(this.config.solicitud.basicos)
          }
          if (typeof this.grupoAsociados !== 'undefined' && this.grupoAsociados.length > 0) {
            this.basicos.push(this.grupoAsociados)
          }
          if (typeof this.grupoFinanciera !== 'undefined' && this.grupoFinanciera.length > 0) {
            this.basicos.push(this.grupoFinanciera)
          }
          if (typeof this.grupoLaboral !== 'undefined' && this.grupoLaboral.length > 0) {
            this.basicos.push(this.grupoLaboral)
          }

          if ((typeof this.grupoSolicitud !== 'undefined' && this.grupoSolicitud.length > 0) ||
            (typeof this.grupoRefFam1 !== 'undefined' && this.grupoRefFam1.length > 0) ||
            (typeof this.grupoSolicitud !== 'undefined' && this.grupoSolicitud.length > 0) ||
            (typeof this.grupoRefFam2 !== 'undefined' && this.grupoRefFam2.length > 0) ||
            (typeof this.grupoRefPer1 !== 'undefined' && this.grupoRefPer1.length > 0) ||
            (typeof this.grupoRefPer2 !== 'undefined' && this.grupoRefPer2.length > 0)) {
            this.solic.push('DATOS SOLICITUD')
            this.solic.push(this.config.solicitud.solic)
          }

          if (typeof this.grupoSolicitud !== 'undefined' && this.grupoSolicitud.length > 0) {
            this.solic.push(this.grupoSolicitud)
          }
          if (typeof this.grupoRefFam1 !== 'undefined' && this.grupoRefFam1.length > 0) {
            this.solic.push(this.grupoRefFam1)
          }
          if (typeof this.grupoRefFam2 !== 'undefined' && this.grupoRefFam2.length > 0) {
            this.solic.push(this.grupoRefFam2)
          }
          if (typeof this.grupoRefPer1 !== 'undefined' && this.grupoRefPer1.length > 0) {
            this.solic.push(this.grupoRefPer1)
          }
          if (typeof this.grupoRefPer2 !== 'undefined' && this.grupoRefPer2.length > 0) {
            this.solic.push(this.grupoRefPer2)
          }

          if (typeof this.grupoCodeudor !== 'undefined' && this.grupoCodeudor.length > 0) {
            this.codeudor.push('CODEUDORES')
            this.codeudor.push(this.config.solicitud.codeudor)
            this.codeudor.push(this.grupoCodeudor)
          }

          if (typeof this.grupoDocumetos !== 'undefined' && this.grupoDocumetos.length > 0) {
            this.documentos.push('DOCUMENTOS')
            this.documentos.push(this.config.solicitud.documentos)
            this.documentos.push(this.grupoDocumetos)

            for (let i = 0; i < this.grupoDocumetos.length; i++) {
              console.log(this.grupoDocumetos[i])
              if (this.grupoDocumetos[i].CAMPOREQUERIDO == 'TRUE') {
                this.docs.push(this.grupoDocumetos[i].NOMBRECAMPO)
              }
            }

            console.log(this.docs)
          }

          if (typeof this.basicos !== 'undefined' && this.basicos.length > 0) {
            this.grupos.push(this.basicos)
          }

          if (typeof this.solic !== 'undefined' && this.solic.length > 0) {
            this.grupos.push(this.solic)
          }

          if (typeof this.codeudor !== 'undefined' && this.codeudor.length > 0) {
            this.grupos.push(this.codeudor)
          }

          if (typeof this.documentos !== 'undefined' && this.documentos.length > 0) {
            this.grupos.push(this.documentos)
          }

          this.formularioSolicitud.forEach(element => {
            if (element.TIPOINPUTCAMPO === 'select' || element.TIPOINPUTCAMPO === 'option') {
              this.SelectDinamico(element.TABLAOPTION, element.ITEM1, element.ITEM2, element.ITEM3, element.NOMBRECAMPO);
            } else if (element.TIPOINPUTCAMPO === 'check') {
              this.Check(element.NOMBRECAMPO, element.TABLAOPTION, element.ITEM1, element.ITEM2)
            }
          });
          this.getDatos()


        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Hubo un problema al cargar el formulario, por favor intentelo mas tarde' });
          this.spinner.hide()
        }
      }
    )
  }

  insertarDireccion(nombreCampo, fam) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '60%';
    const modalRef = this.dialog.open(DireccionesComponent, {
      autoFocus: false,
      maxHeight: '80vh' //you can adjust the value as per your view
    });
    modalRef.afterClosed().subscribe(res => {

      if (res.dir != null && res.dir != undefined && res.dir != 'undefined' && res.dir != false) {
        this.solicitud[nombreCampo] = res.dir;
      }
    })
  }

  async guardar(forma, envia) {
    if (envia) {
      if (this.verificaDoc()) {
        if (this.aceptaAutorizacion()) {
          let valor
          if (this.solicitud.MONTO.toString().indexOf('$') >= 0) {
            valor = this.solicitud.MONTO.toString()
            valor = valor
            for (let i = 0; i < valor.length; i++) {
              if (valor.indexOf('.') >= 0) {
                valor = valor.replace(".", '');
              }
            }
            this.solicitud.MONTO = valor.replace('$', '');
          }
          valor = ''
          if (this.solicitud.ACTIVOS.toString().indexOf('$') >= 0) {
            valor = this.solicitud.ACTIVOS.toString()
            valor = valor
            for (let i = 0; i < valor.length; i++) {
              if (valor.indexOf('.') >= 0) {
                valor = valor.replace(".", '');
              }
            }
            this.solicitud.ACTIVOS = valor.replace('$', '');
          }
          valor = ''
          if (this.solicitud.PASIVOS.toString().indexOf('$') >= 0) {
            valor = this.solicitud.PASIVOS.toString()
            valor = valor
            for (let i = 0; i < valor.length; i++) {
              if (valor.indexOf('.') >= 0) {
                valor = valor.replace(".", '');
              }
            }
            this.solicitud.PASIVOS = valor.replace('$', '');
          }
          valor = ''
          if (this.solicitud.PATRIMONIO.toString().indexOf('$') >= 0) {
            valor = this.solicitud.PATRIMONIO.toString()
            valor = valor
            for (let i = 0; i < valor.length; i++) {
              if (valor.indexOf('.') >= 0) {
                valor = valor.replace(".", '');
              }
            }
            this.solicitud.PATRIMONIO = valor.replace('$', '');
          }
          valor = ''
          if (this.solicitud.EGRESOS.toString().indexOf('$') >= 0) {
            valor = this.solicitud.EGRESOS.toString()
            valor = valor
            for (let i = 0; i < valor.length; i++) {
              if (valor.indexOf('.') >= 0) {
                valor = valor.replace(".", '');
              }
            }
            this.solicitud.EGRESOS = valor.replace('$', '');
          }
          let date = new Date();
          let day = date.getDate();
          let monthIndex = date.getMonth();
          let year = date.getFullYear();
          let fhaActual = year + '-' + (monthIndex + 1) + '-' + day

          let frecString = ''
          let lineaString = ''

          this.Frecuencia.forEach(element => {
            if (element.codfrecuencia == this.solicitud.FRECUENCIA) {
              frecString = element.frecuencia
            }
          });

          this.lineasCredito.forEach(element => {
            if (element.CODLIN == this.solicitud.CODLINEA) {
              lineaString = element.DESCRIPCION
            }
          });
          if ((parseInt(this.solicitud.MONTO) < this.montoMax) || (parseInt(this.solicitud.MONTO) > this.montoMin)) {
            this.spinner.show();

            this.jsonSend = {
              monto: this.solicitud.MONTO,
              codlin: this.solicitud.CODLINEA,
              coddestino: this.solicitud.DESTINO,
              codasociado: this.identity.CODASOCIADO,
              fhacomite: fhaActual,
              usrcrea: 21,
              hora: date,
              plazo: this.solicitud.PLAZO,
              adjunto1: this.solicitud.adjunto1,
              adjunto2: this.solicitud.adjunto2,
              adjuntos: this.solicitud.adjuntos,
              seguro: this.solicitud.SEGURO,
              tasa: 0,
              datosUsuario: this.identity,
              codeudor1: this.solicitud.CODEUDOR1,
              codeudor2: this.solicitud.CODEUDOR2,
              codeudores: this.solicitud.CODEUDORES,
              afianza: this.solicitud.AFIANZA,
              codfrec: this.solicitud.FRECUENCIA,
              recogeCreditos: this.solicitud.RECOGECRED,
              numCredRecoge: this.solicitud.CREDRECOGE,
              datosCredRecoge: this.solicitud.DATOSCREDRECOGE,
              plazoLetras: frecString,
              lineaLetras: lineaString,
              datosGeneral: this.datosGenerales,
              datosSolicitud: {
                observaciones: this.solicitud.observaciones,
                CODLINEA: this.solicitud.CODLINEA,
                LINEA: lineaString,
                PLAZO: this.solicitud.PLAZO,
                CODDESTINO: this.solicitud.DESTINO,
                CODFREC: this.solicitud.FRECUENCIA,
                RECOGECRED: this.solicitud.RECOGECRED,
                NUMCREDRECOGE: this.solicitud.CREDRECOGE,
                FONDOMUTUAL: 'S',
                NOMBRESREFFAMILIAR1: this.solicitud.NOMBRESREFFAMILIAR1,
                DIRECCIONREFFAMILIAR1: this.solicitud.DIRECCIONREFFAMILIAR1,
                CELULARREFFAMILIAR1: this.solicitud.CELULARREFFAMILIAR1,
                CIUDADREFFAMILIAR1: this.solicitud.CIUDADREFFAMILIAR1,

                NOMBRESREFFAMILIAR2: this.solicitud.NOMBRESREFFAMILIAR2,
                DIRECCIONREFFAMILIAR2: this.solicitud.DIRECCIONREFFAMILIAR2,
                CELULARREFFAMILIAR2: this.solicitud.CELULARREFFAMILIAR2,
                CIUDADREFFAMILIAR2: this.solicitud.CIUDADREFFAMILIAR2,

                NOMBRESREFPERSONAL1: this.solicitud.NOMBRESREFPERSONAL1,
                DIRECCIONREFPERSONAL1: this.solicitud.DIRECCIONREFPERSONAL1,
                CELULARREFPERSONAL1: this.solicitud.CELULARREFPERSONAL1,
                CIUDADREFPERSONAL1: this.solicitud.CIUDADREFPERSONAL1,

                NOMBRESREFPERSONAL2: this.solicitud.NOMBRESREFPERSONAL2,
                DIRECCIONREFPERSONAL2: this.solicitud.DIRECCIONREFPERSONAL2,
                CELULARREFPERSONAL2: this.solicitud.CELULARREFPERSONAL2,
                CIUDADREFPERSONAL2: this.solicitud.CIUDADREFPERSONAL2,

                SEGURO: this.solicitud.SEGURO,
                DATOSCREDITORECOGE: this.solicitud.DATOSCREDRECOGE
              }
            }

            console.log(this.jsonSend)
            this._userService.httpPost('guardarSolicitudCredito', this.jsonSend).subscribe(
              (resp: any) => {
                this.spinner.hide();
                if (resp.status == 'success') {
                  this.messageService.add({ severity: 'success', summary: 'Success', detail: resp.message });
                  this.creaSolicitud = false
                  this.solicitud = new solicitud()
                  this.getSolicitudes()
                  this.getSolicitudesCodeudor()
                } else {
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: resp.message });
                }
              },
              error => {
                console.log(error)
                this.spinner.hide()
              }
            )
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'El monto digitado no cumple con las condiciones de monto máximo o monto mínimo de la línea de crédito ' + lineaString });
          }
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Falta la aceptacion de las autorizaciones' });
        }
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Faltan documentos por subir' });
      }
    }
  }

  getDatos() {
    this.spinner.show();
    this._userService.httpGet('precarga/' + this.identity.CODASOCIADO).subscribe(resp => {
      this.solicitud = resp;
      if (resp.FHA_INGRESO) {
        let d
        if (resp.FHA_INGRESO.toString().indexOf(' ')) {
          let valor = resp.FHA_INGRESO.split(' ');
          d = new Date(valor[0] + ' 11:00');
        } else {
          d = new Date(resp.FHA_INGRESO + ' 11:00');
        }
        this.solicitud.FHA_INGRESO = d.toISOString();
      }
      this.solicitud.CODBANCO = parseInt(this.solicitud.CODBANCO)
      this.solicitud.CODENT = parseInt(this.solicitud.CODENT)
      this.solicitud.CODCARGO = parseInt(this.solicitud.CODCARGO)
      this.datosGenerales = this.solicitud
      this.solicitud.RECOGECRED = 'N'
      this.solicitud.CODEUDORES = 'N'
      this.solicitud.CODEUDOR1 = ''
      this.solicitud.CODEUDOR2 = ''
      this.solicitud.CREDRECOGE = []
      this.solicitud.DATOSCREDRECOGE = []
      this.solicitud.adjunto1 = ''
      this.solicitud.adjunto2 = ''
      this.solicitud.adjuntos = {}
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }

  getLineasCredito() {
    this._userService.httpGet('lineasCredito').subscribe(resp => {
      this.lineasCredito = resp;
      console.log(this.lineasCredito)
    }, error => {
      alert('lc: ' + error as any)
      console.log(error as any);
    });
  }

  getDestinoCredito() {
    this._userService.httpGet('destinoCredito').subscribe(resp => {
      this.destinos = resp
    })
  }

  SelectDinamico($tabla, $item1, $item2, $item3, $campo) {
    //this._userService.SelectDinamico($tabla, $item1, $item2, $item3).subscribe(
    if ($campo != 'CODLINEA' || $campo != 'PLAZO' || $campo != 'FRECUENCIA') {
      this.solicitud.tabla = $tabla
      this.solicitud.item1 = $item1
      this.solicitud.item2 = $item2
      this.solicitud.item3 = $item3
      this._userService.httpPost('selectDinamico', this.solicitud).subscribe(
        response => {
          this.select[$campo] = response;
        },
        error => {
          console.log(<any>error);
          this.spinner.hide()
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Hubo un problema al cargar el formulario, por favor intentelo de nuevo mas tarde' });
        }
      );
    }
  }

  Check(campo, tabla, item1, item2) {
    this.solicitud = tabla
    this.solicitud = item1
    this.solicitud = item2
    this._userService.httpPost('check', this.solicitud).subscribe(
      response => {
        this.Check[campo] = response
      }
    )
  }

  CiudadesFiltro(campoS, valor, tipo, valid, campoN) {
    if (campoS != null && campoS != undefined) {
      if (campoS.toString().indexOf(';') >= 0) {
        this.camposSeparadosS = campoS.split(';');
      } else {
        this.camposSeparadosS = campoS;
      }
    }

    if (campoN != null && campoN != undefined) {
      if (campoN.toString().indexOf(';') >= 0) {
        this.camposSeparadosN = campoN.split(';');
      } else {
        this.camposSeparadosN = campoN;
      }
    }

    if (tipo == 'FILTROSELECT') {

      valor = valor.toUpperCase();
      this.campoFiltrada[campoS] = this.select[campoS].filter(item => {
        return item.DESCRIPCION.toLowerCase().indexOf(
          valor.toLowerCase()) > -1;
      });

    } else if (tipo == 'DISABLEDCAMPO') {
      if (valor.value == valid) {
        console.log(this.camposSeparadosS)
        if (this.camposSeparadosS) {
          this.camposSeparadosS.forEach(camposSeparadosVS => {
            this.grupos.forEach(grupo => {
              grupo.slice(2).forEach(elements => {
                console.log(elements)
                elements.forEach(element => {
                  if (element.NOMBRECAMPO == camposSeparadosVS) {
                    element.DISABLEDCAMPO = 'false';
                  }
                });
              });
            });
          });
        }

        if (this.camposSeparadosN) {
          this.camposSeparadosN.forEach(camposSeparadosVN => {
            this.grupos.forEach(grupo => {
              grupo.slice(2).forEach(elements => {
                elements.forEach(element => {
                  if (element.NOMBRECAMPO == camposSeparadosVN) {
                    element.DISABLEDCAMPO = 'true';
                  }
                });
              });
            });
          });
        }
      } else {
        if (this.camposSeparadosS) {
          this.camposSeparadosS.forEach(camposSeparadosVS => {
            this.grupos.forEach(grupo => {
              grupo.slice(2).forEach(elements => {
                elements.forEach(element => {
                  if (element.NOMBRECAMPO == camposSeparadosVS) {
                    element.DISABLEDCAMPO = 'true';
                  }
                });
              });
            });
          });
        }
        if (this.camposSeparadosN) {
          this.camposSeparadosN.forEach(camposSeparadosVN => {
            this.grupos.forEach(grupo => {
              grupo.slice(2).forEach(elements => {
                elements.forEach(element => {
                  if (element.NOMBRECAMPO == camposSeparadosVN) {
                    element.DISABLEDCAMPO = 'false';
                  }
                });
              });
            });
          });
        }
      }
    }
    else if (tipo == 'GETPLAZOS') {
      this.getPlazosCredito(valor)
    }
    else if (tipo == 'RECOGECRED') {
      if (valor.value == 'S') {
        if (this.solicitud.MONTO != '' && this.solicitud.MONTO != null) {
          let date = new Date();
          let day = date.getDate();
          let monthIndex = date.getMonth();
          let year = date.getFullYear();
          let data = {
            codasociado: this.identity.CODASOCIADO,
            fhasta: year + '-' + (monthIndex + 1) + '-' + day,
            recoge: true,
            pse: false
          };
          this._userService.httpPost('cartera', data).subscribe(
            response => {
              if (response.status != 'error') {
                this.carteraRecoge = response.details;
                let valor;
                if (this.solicitud.MONTO.toString().indexOf('$') >= 0) {
                  valor = this.solicitud.MONTO.toString()
                  valor = valor
                  for (let i = 0; i < valor.length; i++) {
                    if (valor.indexOf('.') >= 0) {
                      valor = valor.replace(".", '');
                    }
                  }
                  this.solicitud.MONTO = valor.replace('$', '');
                }
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.width = '60%';
                const modalRef = this.dialog.open(RecogeCreditosComponent, {
                  autoFocus: false,
                  maxHeight: '80vh', //you can adjust the value as per your view
                  data: { monto: this.solicitud.MONTO }
                });

                modalRef.afterClosed().subscribe(result => {
                  console.log('The dialog was closed');
                  console.log(result)

                  if (result.numCredRecoge) {
                    this.solicitud.NUMCREDRECOGE = result.numCredRecoge
                    this.solicitud.CREDRECOGE = result.pagares
                    this.solicitud.DATOSCREDRECOGE = result.creditos
                  } else {
                    this.solicitud.RECOGECRED = 'N'
                  }
                });
              } else {
                console.log(response.details)
              }
              this.spinner.hide()
            },
            error => {
              console.log(<any>error);
              this.spinner.hide()
            }
          );
        } else {

          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Se requiere un monto' });
        }
      } else {
        console.log('no recoge')
        this.solicitud.NUMCREDRECOGE = ''
        this.solicitud.CREDRECOGE = ''
        this.solicitud.DATOSCREDRECOGE = ''
      }
    }
    else if (tipo == 'CODEXT') {
      console.log('codext')

      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.width = '60%';
      const modalRef = this.dialog.open(CodeudoresExternosComponent, {
        autoFocus: false,
        maxHeight: '80vh' //you can adjust the value as per your view
      });

      modalRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        console.log(result)

        this.solicitud[campoS] = result.nit
      });
    }
  }

  getPlazosCredito(linea) {
    this.solicitud.PLAZO = ''
    this.spinner.show();
    this._userService.httpGet('plazosCredito/' + linea).subscribe(resp => {
      this.spinner.hide();
      const plazomax = resp.PLAZMAX;
      this.condicionesLineaCredito = resp.CONDICIONES;
      this.montoMax = resp.MONTO_MAXIMO
      this.montoMin = resp.MONTO_MINIMO
      if (this.condicionesLineaCredito != null) {
        this.messageService.add({ severity: 'info', summary: 'Condiciones de la línea de crédito', detail: this.condicionesLineaCredito });
      }
      this.plazos = Array();
      for (let i = 1; i <= plazomax; i++) {
        this.plazos.push({
          CODPLAZO: i,
          PLAZO: i
        });
      }
      this._userService.httpGet('listarSeguroCredito/' + linea).subscribe(resp => {
        if (resp.status === 'success') {
          this.solicitud.SEGURO = resp.details
        } else {
          this.solicitud.SEGURO = 0
        }
      }, error => {
        this.spinner.hide();
        console.log(error as any);
      });
    }, error => {
      this.spinner.hide();
      console.log(error as any);
    });
  }

  getFrecuencia() {
    this._userService.httpGet('frecuenciasCredito').subscribe(resp => {
      this.Frecuencia = resp.details;
    }, error => {
      console.log(error);
    });
  }

  subida(event, nombre) {
    console.log(event)
    if (event.originalEvent.body) {
      if (event.originalEvent.body.status == 'success') {
        console.log(event.originalEvent.body)
        this.solicitud.adjuntos[nombre] = event.originalEvent.body.filename
        this.messageService.add({ severity: 'success', summary: 'Success', detail: event.originalEvent.body.message });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: event.originalEvent.body.message });
      }
    }


  }

  getTrackingSolicitud(soli) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '60%';
    const modalRef = this.dialog.open(ViewTrackingComponent, {
      autoFocus: false,
      maxHeight: '80vh', //you can adjust the value as per your view
      data: { solicitud: soli }
    });
  }

  firmaPagare(soli, user) {

    this._userService.httpGet('validarActualizacion/' + this.identity.CODASOCIADO).subscribe(resp => {
      if ((resp.ACTUALIZA === 1 || resp.ACTUALIZA === '1') && this.aplicaActualizaDatos) {
        this.spinner.hide()
        this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Para aceptar o negar la solicitud es necesario actualizar tus datos' });
        //alert('');
        this.router.navigateByUrl('actualizacion');
      } else {
        console.log(this.pdfDeceval)
        Swal.fire({
          icon: 'info',
          html:
            'En el siguiente enlace podra visualizar el pagare que va a firmar<br>' +
            '<a href="' + this.pdfDeceval + '" target="_blank" class="btn btn-info btn-sm"><b>Ver Pagare</b></a><br> ' +
            '¿Acepta el pagare desmaterializado?',
          showCancelButton: true,
          allowOutsideClick: false,
          confirmButtonText:
            'Acepto',
          cancelButtonText:
            'No acepto',
        }).then(resp => {
          if (resp.isConfirmed) {
            this.spinner.show()
            console.log(resp)
            let verif = {
              numsol: soli.NUMSOL
            }
            this._userService.httpPost('verificaCodeudorExterno', verif).subscribe(resp => {
              if (resp.N > 0) {
                const datos = {
                  codasociado: this.identity.CODASOCIADO,
                  numsol: soli.NUMSOL,
                  codunico: this.identity.CODUNICO
                };

                console.log("Milton: ", datos);
                this._userService.httpPost('almacenarDatosGirador', datos).subscribe(resp => {
                  console.log("miltonnn", resp);
                  if (resp.status === 'success') {
                    localStorage.setItem('numidentificacionDeceval', resp.details);
                    console.log('entró aqui');
                    const datosAlmacenarPagare = {
                      numsol: soli.NUMSOL,
                      monto: soli.MONTO,
                      nit: this.identity.NIT,
                      codasociado: this.identity.CODASOCIADO,
                      codunico: this.identity.CODUNICO
                    };
                    this._userService.httpPost('almacenarDatosPagare', datosAlmacenarPagare).subscribe(response => {
                      if (response.status === 'success') {
                        this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Señor usuario, ya que esta solicitud cuenta con codeudores externos se creó el pagare en la plataforma de Deceval, pero al titular y a los codeudores del crédito les toca firmar desde la plataforma de Deceval' });
                      }
                    })
                  } else {
                    console.log(resp.message);
                  }
                }, error => {
                  alert(JSON.stringify(error as any));
                });
              } else {
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.width = '60%';
                const modalRef = this.dialog.open(PagarePrincipalComponent, {
                  autoFocus: false,
                  maxHeight: '80vh', //you can adjust the value as per your view
                  data: { solicitud: soli, user: user }
                });
              }
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Operacion cancelada'
            })
          }


          this.spinner.hide()
        })


      }
    }, error => {
      this.spinner.hide()
      console.log(error);
    });

  }

  aceptaSolicitud(soli) {
    //this.spinner.show();
    let acepta;
    /*if (value) {
      acepta = 'A';
    } else {
      acepta = 'R';
    }*/

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '60%';
    const modalRef = this.dialog.open(AceptaSolicitudComponent, {
      autoFocus: false,
      maxHeight: '80vh', //you can adjust the value as per your view
      data: { solicitud: soli }
    });

    modalRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      console.log(result)
      acepta = result.data
      if (acepta != 'N') {
        const data = {
          numsol: soli,
          codasociado: this.identity.CODASOCIADO,
          acepta
        };

        this._userService.httpPost('aceptaCodeudor', data).subscribe(resp => {
          this.spinner.hide();
          console.log(resp)
          this.getSolicitudesCodeudor();
          alert(resp.message);
        }, error => {
          alert(error.message);
        });
      }

    });
  }

  CargarAutorizacion() {
    let auth = [
      "WEB_AUTORIZACION_SOLICITUD_1",
      "WEB_AUTORIZACION_SOLICITUD_2",
      "WEB_AUTORIZACION_SOLICITUD_3"
    ]

    for (let i = 0; i < auth.length; i++) {
      let data = {
        autorizacion: auth[i]
      }
      this._userService.httpPost('cargaEntidad', data).subscribe(
        response => {
          if (response['WEBAUTORIZACION'] != '' && response['WEBAUTORIZACION'] != null) {
            this.autorizaciones.push(response['WEBAUTORIZACION'])
          }
        },
        error => {
          console.log(<any>error);
        }
      );
    }
  }

  aceptaAutorizacion() {
    let returnR = false
    for (let i = 0; i < this.autorizaciones.length; i++) {
      if (this.solicitud['auth' + (i + 1)]) {
        returnR = true
      } else {
        returnR = false
      }
      console.log('auth ' + (i + 1) + " " + this.solicitud['auth' + (i + 1)])
    }
    return returnR
  }

  verificaDoc() {
    let returnR = true
    for (let i = 0; i < this.docs.length; i++) {
      if (this.solicitud.adjuntos[this.docs[i]]) {
        //returnR = true
      } else {
        returnR = false
      }
    }
    return returnR
  }

}

